import {
  ArrayMaxSize,
  ArrayMinSize,
  IsArray,
  IsOptional,
  IsUUID,
} from 'class-validator';

/**
 * Search request for condition history across one or more conditions.
 *
 * RESTRICTION: all supplied condition IDs must belong to the **same patient**
 * (health record). The API enforces this server-side
 * (`DermloopConditionHistoryService.searchConditionHistory` →
 * `verifySameHealthRecord`) and rejects mixed-patient requests with a 400 to
 * prevent cross-patient data leakage in a single response. Because of this
 * single-patient guarantee, auditing the first condition ID is sufficient to
 * attribute the request to the correct patient.
 */
export class SearchConditionHistoryDto {
  /**
   * Condition IDs to fetch history for. Must all belong to the same patient
   * (see class-level restriction).
   */
  @IsOptional()
  @IsArray()
  @ArrayMinSize(1)
  @ArrayMaxSize(20)
  @IsUUID('all', { each: true })
  conditionIds?: string[];

  /**
   * @deprecated Use conditionIds. Must all belong to the same patient (see
   * class-level restriction).
   */
  @IsOptional()
  @IsArray()
  @ArrayMinSize(1)
  @ArrayMaxSize(20)
  @IsUUID('all', { each: true })
  skinConditionIds?: string[];
}
